import { get } from 'lodash'
import React from 'react'
import { FormSpy } from 'react-final-form'

import JsonView from '../JsonView'

type TFormState = {
  limitToPath?: string
  expanded?: boolean
}

const FormState = (props: TFormState): React.ReactElement => {
  const { expanded = true, limitToPath = undefined } = props

  return (
    <FormSpy subscription={{ values: true }}>
      {({ values }) => (
        <JsonView
          json={limitToPath ? get(values, `${limitToPath}`) : values}
          expanded={expanded}
        />
      )}
    </FormSpy>
  )
}

export default FormState
